<template>
  <div class="week-gift-config">
    <div class="week-gift-config--process">
      <span>周期：</span>
      <el-select v-model="searchData.weekDuration" placeholder="请选择周期">
        <el-option label="ALL" value=""></el-option>
        <el-option
          v-for="item in durationTimeList"
          :key="item"
          :label="item"
          :value="item"
        >
        </el-option>
      </el-select>
      <span>是否可用：</span>
      <el-select v-model="searchData.valid" placeholder="请选择是否可用">
        <el-option label="可用" :value="1"></el-option>
        <el-option label="不可用" :value="0"></el-option>
      </el-select>
      <el-button type="primary" @click="getGiftList(true)">查询</el-button>
      <el-button type="success" @click="addDialogShow">新增</el-button>
    </div>
    <el-table
      ref="giftTable"
      :data="giftList"
      style="width: 100%"
      max-height="660"
      height="660"
    >
      <el-table-column prop="id" label="id"> </el-table-column>
      <el-table-column prop="eventCode" label="活动码"></el-table-column>
      <el-table-column prop="weekDuration" label="周期"></el-table-column>
      <el-table-column prop="giftId" label="礼物id"> </el-table-column>
      <el-table-column prop="icon" label="图标">
        <template slot-scope="scope">
          <img :src="scope.row.icon" alt="" style="width: 50px" />
        </template>
      </el-table-column>
      <el-table-column label="操作" width="180">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="updateDialogShow(scope.row)"
            >修改</el-button
          >
          <el-button size="mini" type="success" @click="exportThis(scope.row)">
            导出
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="prev, pager, next"
      :total="total"
      :current-page.sync="searchData.page"
    >
    </el-pagination>

    <el-dialog
      title="新增礼物配置"
      :visible.sync="addData.visible"
      @close="closeAddGift"
      width="30%"
    >
      <el-form :model="addData.data">
        <el-form-item label="开始时间">
          <el-date-picker
            v-model="addData.data.beginDate"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间">
          <el-date-picker
            v-model="addData.data.endDate"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="礼物id">
          <el-input
            v-model.number="addData.data.giftId"
            autocomplete="off"
            style="width: 200px"
            placeholder="请输入礼物id"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addData.visible = false">取 消</el-button>
        <el-button type="primary" @click="submitGiftData">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="修改礼物配置" :visible.sync="updateData.visible" width="30%">
      <el-form :model="updateData.data">
        <el-form-item label="礼物id">
          <el-input
            v-model="updateData.data.giftId"
            autocomplete="off"
            style="width: 200px"
            placeholder="请输入礼物id"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="是否有效">
          <el-select v-model="updateData.data.valid" placeholder="请选择是否可用">
            <el-option label="有效" :value="1"></el-option>
            <el-option label="无效" :value="0"></el-option>
          </el-select>
        </el-form-item> -->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="updateData.visible = false">取 消</el-button>
        <el-button type="primary" @click="submitUpdateGift">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import download from "@/utils/download.js";
import {
  getGiftDuration,
  getWeekGiftList,
  createWeekGift,
  updateWeekGift,
  exportWeekGift,
} from "@/api/weekStarRequest";
export default {
  data() {
    return {
      total: 0,
      searchData: {
        weekDuration: "",
        valid: 1,
        page: 1,
      },
      durationTimeList: [],
      giftList: [],
      addData: {
        visible: false,
        data: {
          giftId: "",
          beginDate: "",
          endDate: "",
        },
      },
      updateData: {
        visible: false,
        data: {},
      },
      updateDialogVisible: false,
    };
  },
  methods: {
    // 导出数据
    async exportThis(row) {
      const res = await exportWeekGift(row);
      console.log(res);
      download(res, row.weekDuration + "");
    },
    // 操作成功后的统一处理
    async processHandle(res) {
      if (res.code !== 0) return this.$message.error(res.msg);
      this.$message.success("success");
      await this.getGiftDurationList();
      await this.getGiftList();
    },
    // 新增弹窗展示
    addDialogShow() {
      this.addData.visible = true;
    },
    // 提交新增礼物
    async submitGiftData() {
      const res = await createWeekGift(this.addData.data);
      this.processHandle(res);
      if (res.code !== 0) return;
      this.addData.visible = false;
    },
    // 关闭新增礼物回调
    closeAddGift() {
      this.addData.data = {
        giftId: "",
        beginDate: "",
        endDate: "",
      };
    },
    updateDialogShow(row) {
      this.updateData.data = JSON.parse(JSON.stringify(row));
      this.updateData.visible = true;
    },
    async submitUpdateGift() {
      const res = await updateWeekGift({
        id: this.updateData.data.id,
        giftId: this.updateData.data.giftId,
      });
      this.processHandle(res);
      this.addData.visible = false;
    },
    async getGiftDurationList() {
      const res = await getGiftDuration();
      if (res.code !== 0) return this.$message.error(res.msg);
      this.durationTimeList = res.data;
    },
    // bool true 页码为1
    async getGiftList(bool) {
      if (bool) this.searchData.page = 1;
      const res = await getWeekGiftList(this.searchData);
      if (res.code !== 0) return this.$message.error(res.msg);
      this.giftList = res.data.data;
      this.total = res.data.total;
      this.$message.success("search success");
      setTimeout(() => {
        this.$refs.giftTable.doLayout();
      }, 1000);
    },
  },
  async mounted() {
    await this.getGiftDurationList();
    await this.getGiftList(true);
  },
};
</script>

<style scoped lang="scss">
.week-gift-config {
  &--process {
    .el-select {
      margin-right: 20px;
    }
  }
}
</style>
